import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Badge } from "./ui/badge";
import { Separator } from "./ui/separator";
import { fmtRM } from "../i18n";

const Row = ({ label, value, bold, mono = true }) => (
  <div className="flex justify-between text-sm py-1">
    <span className={bold ? "font-semibold" : "text-slate-600"}>{label}</span>
    <span className={`${mono ? "font-mono" : ""} ${bold ? "font-bold" : "font-medium"}`}>{value}</span>
  </div>
);

export default function PayslipModal({ payslip, open, onClose, company }) {
  if (!payslip) return null;
  const e = payslip.earnings, d = payslip.deductions, er = payslip.employer;
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-md" data-testid="payslip-modal" aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle className="flex items-center justify-between pr-6">
            <span>{company || "WORKAHOLIC HR"}</span>
            <Badge variant="outline" className="font-mono">{payslip.period}</Badge>
          </DialogTitle>
        </DialogHeader>
        <div className="bg-white border rounded-lg p-4 text-slate-900">
          <p className="font-semibold">{payslip.employee_name}</p>
          <p className="text-xs text-slate-500 font-mono">{payslip.emp_no} · {payslip.position} · {payslip.department}</p>
          <Separator className="my-3" />
          <p className="text-xs font-semibold uppercase tracking-wider text-slate-400 mb-1">Earnings</p>
          <Row label="Basic Salary" value={fmtRM(e.basic)} />
          <Row label="Fixed Allowance" value={fmtRM(e.fixed_allowance)} />
          {e.ot_pay > 0 && <Row label={`Overtime (${e.ot_hours}h @ ${fmtRM(e.ot_rate)}/h)`} value={fmtRM(e.ot_pay)} />}
          <Row label="Gross Pay" value={fmtRM(e.gross)} bold />
          <Separator className="my-3" />
          <p className="text-xs font-semibold uppercase tracking-wider text-slate-400 mb-1">Deductions</p>
          <Row label="EPF Employee" value={fmtRM(d.epf_employee)} />
          <Row label="SOCSO Employee" value={fmtRM(d.socso_employee)} />
          <Row label="EIS Employee" value={fmtRM(d.eis_employee)} />
          <Row label="PCB (MTD)" value={fmtRM(d.pcb)} />
          <Row label="Total Deductions" value={fmtRM(d.total)} bold />
          <Separator className="my-3" />
          <div className="flex justify-between items-center bg-slate-900 text-white rounded-lg px-3 py-2.5">
            <span className="text-sm font-semibold">NET PAY</span>
            <span className="font-mono font-extrabold text-lg" data-testid="payslip-net-pay">{fmtRM(payslip.net_pay)}</span>
          </div>
          <Separator className="my-3" />
          <p className="text-xs font-semibold uppercase tracking-wider text-slate-400 mb-1">Employer Contributions</p>
          <Row label="EPF Employer" value={fmtRM(er.epf_employer)} />
          <Row label="SOCSO Employer" value={fmtRM(er.socso_employer)} />
          <Row label="EIS Employer" value={fmtRM(er.eis_employer)} />
          <Row label="Total Employment Cost" value={fmtRM(er.total_cost)} bold />
          <p className="mt-3 text-[10px] text-slate-400 font-mono">
            Rules: EPF {payslip.rules_versions?.EPF} · SOCSO {payslip.rules_versions?.SOCSO} · EIS {payslip.rules_versions?.EIS} · PCB {payslip.rules_versions?.PCB}
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
